import Loading from '@components/shared/Loading';
import { useCurrentCampaign } from '../../hooks/useCampaign';
import { useCurrentReport, useCurrentReports } from '../../hooks/useReports';
import { RealTimeOptimization } from './RealTimeOptimization';
import { Alert } from '@mui/material';
import { useRslAIInsights } from '../../hooks/useRslAIInsights';

export const RealTimeOptimizationContainer = () => {
  const { report, loading } = useCurrentReport();
  const { reports, loading: loadingAllReports } = useCurrentReports();
  const { campaign, isFetching: loadingCampaign } = useCurrentCampaign();
  const { rslAiInsights } = useRslAIInsights(
    report ?? null,
    'top-bottom-performers'
  );

  if (loading || loadingAllReports || loadingCampaign) return <Loading />;

  if (!report || !campaign)
    return <Alert severity="error">Error loading campaign data.</Alert>;

  return (
    <RealTimeOptimization
      report={report}
      reports={reports}
      campaignName={campaign.name}
      aiInsights={rslAiInsights}
    />
  );
};
